import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '../modules/layout/components/ToastContext';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    showToast(t('PageNotFoundRedirect'), 'warning');

    return () => clearTimeout(timeout);
  }, [showToast, t]);

  const timeout = setTimeout(() => {
    navigate('/auth/login');
  }, 4000);

  return (<></>);
};

export default NotFoundPage;
